interface PostTitleProps {
  children: string
}
const PostTitle: React.FC<PostTitleProps> = ({ children }) => (
  <h1
    dangerouslySetInnerHTML={{ __html: children }}
    className='mx-auto mb-6 max-w-3xl text-center text-3xl font-semibold leading-tight tracking-tighter text-gray-800 sm:mb-8 sm:px-4 md:mb-7 md:text-center md:text-5xl md:leading-none lg:font-bold'
  />
)

export default PostTitle
